import React from "react";
import {connect} from "react-redux";
import {
    Page,
    ContainerLeft,
    ContainerRight,
    Feedback
} from "components/layouts";
import {Text} from "components/styled";
import {contactLocalization} from "localization";
import styled from "styled-components";
import {media} from "../../components/styled/utils";

const Contact = ({selectedLanguage, municipality}) => {
  console.log(municipality);
    const {
        title,
        text,
        addressText1,
        addressText2,
        addressText,
        phoneText,
        phone,
        emailText,
        email1,
        email2,
        website,
        tollFree,
        tollFreeText
    } = contactLocalization[selectedLanguage];
    return (
        <Page>
            <ContainerLeft>
                <ContactWrap className="contact-wrap" lang={selectedLanguage}>
                    <div className="main-title">{title}</div>
                    <div>
                        <Text>{text}</Text>
                    </div>
                    <Feedback municipality={municipality}/>
                </ContactWrap>
            </ContainerLeft>
            <ContainerRight>
                <ContactAddress lang={selectedLanguage} className="contact-address">
                  <address>
                      <label className={'contact-label'}>{addressText}</label>
                      {addressText1} <br/>
                      {addressText2}
                      <label  className={'contact-label'}>{phoneText}</label>{" "}
                      <a className={'link'} href={'callto:' + phone}>{phone}</a> <br/>
                      {tollFree ? 
                        <React.Fragment>
                          <a className={'link'} href={'callto:' + tollFree}>{tollFree}</a>{" " + tollFreeText} <br/>
                        </React.Fragment> : ''}
                      <label  className={'contact-label'}>
                        {emailText}
                      </label>
                      <span>
                        <a className={'link mb-1'} href={'mailto:' + email1}>{email1}</a>
                        <br/>
                        <a className={'link'} href={'mailto:' + email2}>{email2}</a>
                      </span>
                      {
                        website ?
                        <React.Fragment>
                          <label  className={'contact-label'}>{'Website'}</label>{" "}
                          <a className={'link'} href={website}>{website}</a> <br/>
                        </React.Fragment> : ''
                      }
                  </address>
                </ContactAddress>
            </ContainerRight>
        </Page>
    );
};

const ContactWrap = styled.div`
  width: 100%;
  ${media.tabletSmall`width:70%`};
  /* ${media.tabletWide`width:50%`}; */
  form input {
    font-size: ${props => (props.lang === "en" ? "14px" : "16px")}!important;
  }
  .btn--ghost {
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")}!important;
  }
`;

const ContactAddress = styled.div`
  padding: 98px 58px;
  address {
    font-size: ${props => (props.lang === "en" ? "15px" : "17px")};
    a {
      display: inline-block;
      text-decoration: none;
    }
    label {
      display: block;
      font-size: 13px;
      font-weight: ${props => props.theme.fontWeight.bold};
      margin-bottom: 4px;
      text-transform: uppercase;
      opacity: 0.3;
      &:not(:first-of-type) {
        margin-top: 40px;
      }
    }
    span {
      display: inline-block;
      font-size: 15px !important;
      vertical-align: top;
      width: 80%;
    }
  }
  h2 {
    font-size: ${props => props.theme.fontSize.lg}px;
    font-weight: ${props => props.theme.fontWeight.bold};
    margin-bottom: 20px;
  }
`;

export default connect(state => ({
  selectedLanguage: state.localizationReducers.selectedLanguage
}))(Contact);



// WEBPACK FOOTER //
// ./src/pages/contact/contact.js